<template>
  <v-app id="app">
    <v-content>
      <modal
        v-if="cambiarEstadoModal"
        @actualizarOpcion="valorOpcion"
      ></modal>
      <loading v-show="getCargando"
        :barraProgreso="barraProgreso"
        :valorProgreso="valorProgreso"
      ></loading>
      <router-view
        :valorSeleccionadoDialogo="valorSeleccionadoDialogo"
        @barra-progreso="actualizarBarraProgreso"
        @valor-progreso="actualizarValorProgreso"
      ></router-view>
    </v-content>
  </v-app>
</template>


<script>
import "babel-polyfill";
import loading from "./components/Loading";
import Modal from "./components/Modal/Modal";
// import "./assets/sass/main.scss";

export default {
  name: "app",
  data() {
    return {
      user: "",
      valorSeleccionadoDialogo: "",
      barraProgreso: false,
      valorProgreso: 0
    };
  },
  created() {
    this.$store.dispatch("setCargando", false);
  },
  components: {
    loading,
    Modal
  },
  computed: {
    cambiarEstadoModal() {
      return this.$store.getters.getEstadoModal;
    },
    getCargando() {
      if (this.$store.getters.getCargando != null) {
        return this.$store.getters.getCargando;
      }
    }
  },
  methods: {
    actualizarBarraProgreso(valor) {
      console.log('actualizarBarraProgreso', valor)
      this.barraProgreso = valor;
    },
    actualizarValorProgreso(valor) {
      this.valorProgreso = valor;
    },
    valorOpcion: function(valor) {
      this.valorSeleccionadoDialogo = valor;
    }
  }
};
</script>

<style lang="scss">
@import "assets/sass/main.scss";

#app {
  font-family: "Nunito", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.v-date-picker-years {
  display: grid;
}
h1,
h2 {
  font-weight: normal;
}
h3 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  // margin: 0 10px;
}
a {
  color: #42b983;
}
button.v-expansion-panel-header {
  height: auto;
}
// poner el texto del label de vuetify con interlineado
.v-label {
  // @extend %texto-alternativo;
  font-size: 16px;
  line-height: 12px !important;
}

@media screen and (max-width: 1366px) {
  .v-label {
    // @extend %texto-alternativo;
    font-size: 12px;
    // top: -20px !important;
    line-height: 5px;
  }
}
.v-application {
  font-family: "Nunito", sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/App.vue